/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step4_Permissions_HeaderInputs */



/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Spaces_Wizard_Step4_Permissions_HeaderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step4_permissions_header = /** @type {((inputs?: Spaces_Wizard_Step4_Permissions_HeaderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step4_Permissions_HeaderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen")
	return /** @type {LocalizedString} */ ("Permissions")
});